import buildOfferObject from './buildOfferObject.js';
import buildHooksObject from './buildHooksObject.js';
async function buildInitObject(isMobile, route, hooks, sponsor, config, paymentsInfo, walletId) {
  let pixall = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
  let dealXgId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  let shopper = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : {};
  let listing = arguments.length > 10 ? arguments[10] : undefined;
  let listedPrice = arguments.length > 11 ? arguments[11] : undefined;
  const isAccelerateTenant = config?.ecommerce === 'Accelerate';
  let sdpRoute = route;
  if (isAccelerateTenant && (route === 'tradeInManual' || route === 'tradeInManualEntry')) {
    sdpRoute = 'tradeInSearch';
  }
  const widgetVersion = isAccelerateTenant ? '6.1.0' : '1.0.0';
  const offer = await buildOfferObject(sponsor, config, paymentsInfo, walletId, dealXgId, shopper, listing, listedPrice);
  return {
    // init object
    isMobile,
    version: widgetVersion,
    source: 'SPONSOR',
    offer,
    hooks: await buildHooksObject(hooks, offer, config?.selectedCriteria),
    route: sdpRoute,
    pixall
  };
}
export { buildInitObject as default };
